import { createFileRoute } from "@tanstack/react-router"
import { SpendingPage } from "@/features/crawl-dashboard/SpendingPage"

export const Route = createFileRoute("/crawl/spending")({
	component: SpendingPage,
})
